module.exports = __webpack_public_path__ + "aquarius-04394483eacfff8d4783.png";